import { useFetchApi, UseFetchDataResponse } from "../ssc-api/useFetchApi";

type GatsbyPageData = {
  componentChunkName: string;
  path: string;
  result: {
    data: unknown;
  };
};

const useFetchModalData = <T>(path: string): UseFetchDataResponse<T> => {
  const { status, data, isError, isLoading } = useFetchApi<GatsbyPageData>(
    `/page-data/modals${path.replace(".html", "")}/page-data.json`
  );
  if (status == "success")
    return { isError, isLoading, data: data?.result?.data as T, status };
  return { status, isError, isLoading, data: undefined };
};

export default useFetchModalData;
